'use client';

import React from 'react';
import { TasticProps } from 'frontastic/tastics/types';
import Heading from 'components/commercetools-ui/organisms/heading';
import { HeadingAlignment, HeadingProps } from 'components/commercetools-ui/organisms/heading/types';

interface Props extends HeadingProps {
  mobileAlignment?: HeadingAlignment;
  tabletAlignment?: HeadingAlignment;
  desktopAlignment?: HeadingAlignment;
}

const HeadingTastic = ({ data }: TasticProps<Props>) => {
  return (
    <Heading
      title={data.title}
      description={data.description}
      buttonText={data.buttonText}
      buttonLink={data.buttonLink}
      buttonVariant={data.buttonVariant}
      theme={data.theme}
      alignment={{
        mobile: data.mobileAlignment || 'center',
        tablet: data.tabletAlignment || 'center',
        desktop: data.desktopAlignment || 'center',
      }}
    />
  );
};

export default HeadingTastic;
